document.addEventListener('DOMContentLoaded', () => {
  const masterContainer = document.querySelector('.collection-articles-carousel');
  const container = document.querySelector('.collection-articles-carousel-container');
  const containerCardList = document.querySelector('.collection-articles-carousel-cardlist');
  const cards = document.querySelectorAll('.collection-articles-carousel-card');
  const leftButton = document.querySelector('.collection-articles-button-left');
  const rightButton = document.querySelector('.collection-articles-button-right');
  let currentCard = 0;
  var clientContainerWidth =  container.clientWidth;
  var maxVisibleCards = 3;
  var offsetAmount = 320;
  var minWidth = 300;
  var swipeAmount = 0;
  var swipeSpeed = 4;
  const offsetPadding = 20;
 
  updateResize();
  
  leftButton.addEventListener('click', () => {
    if(currentCard > 0)
    {
      currentCard--;
      updateCarousel();
    }
  });

  rightButton.addEventListener('click', () => {
    if(currentCard < cards.length - maxVisibleCards)
    {
      currentCard++;
      updateCarousel();
    }
  });

  function updateCarousel() {
    const offset = (-currentCard * offsetAmount) + swipeAmount;
    containerCardList.style.transform = 'translate('+offset+'px)'
    //console.log("offset = " + offset);

    UpdateLeftButtonState();
    UpdateRightButtonState();
  }


  function updateResize() {
    //console.log('updateResize container.clientWidth = ' + container.clientWidth);
    clientContainerWidth = container.clientWidth;

    maxVisibleCards = 3;
    if(clientContainerWidth < 900)
    {
      maxVisibleCards = 2;
    }
    if(clientContainerWidth < 500)
    {
      maxVisibleCards = 1;
    }

    var cardWidth = (clientContainerWidth / maxVisibleCards) - ((offsetPadding * (maxVisibleCards -1)) / maxVisibleCards);
    for(let i = 0; i < cards.length; i++)
    {
      //console.log('updateResize i = ' + i);
      cards[i].style.width = cardWidth + 'px';
    }


    offsetAmount = cardWidth + offsetPadding;
    updateCarousel();
  }


  function UpdateLeftButtonState()
  {
    if(cards.length == 1)
    {
      leftButton.classList.add("disabled");
      return;
    }
    
    if(currentCard == 0)
    {
      leftButton.classList.add("disabled");
    }
    else
    {
      leftButton.classList.remove("disabled");
    }
  }

  function UpdateRightButtonState()
  {
    if(cards.length <= maxVisibleCards)
    {
      rightButton.classList.add("disabled");
      return;
    }
    
    if(currentCard == cards.length - maxVisibleCards)
    {
      rightButton.classList.add("disabled");
    }
    else{
      rightButton.classList.remove("disabled");
    }
  }



  var startSwipeX;
  var currentSwipeX;
  var endSwipeX;

  function swipeStartHandler(e)
  {
    startSwipeX = e.touches[0].clientX - swipeAmount;
    //console.log('startSwipeX ' + startSwipeX);
  }
  function swipeCurrentHandler(e)
  {
    var swipeDirection = -1;
    if(e.touches[0].clientX > currentSwipeX)
    {
      swipeDirection = 1;
    }
    currentSwipeX = e.touches[0].clientX;
    //console.log('currentSwipeX ' + currentSwipeX);
    //swipeAmount += swipeDirection * swipeSpeed;
    
    swipeAmount = currentSwipeX - startSwipeX;
    updateCarousel();
  }
  function swipeEndHandler(e)
  {
    endSwipeX = currentSwipeX;
    //console.log('endSwipeX ' + endSwipeX);
    //console.log('swipeAmount' + swipeAmount);
    currentCard = Math.round(((currentCard * offsetAmount) - swipeAmount) / offsetAmount);
    //console.log('currentCard' + currentCard);
    
    swipeAmount = 0;

    if(currentCard < 0) 
      currentCard = 0;
    if(currentCard >= cards.length - maxVisibleCards) 
      currentCard = cards.length - maxVisibleCards;
    
    updateCarousel();
  }

  window.addEventListener('resize', updateResize);
  masterContainer.addEventListener('touchstart', swipeStartHandler);
  masterContainer.addEventListener('touchmove', swipeCurrentHandler);
  masterContainer.addEventListener('touchend', swipeEndHandler);
});


